import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { LicenseStatus } from "../../../../types/status";



type MachineLicensesFilterProps = {
    onChange: (value: string[]) => void;
    value?: string[];
};

const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;

export const MachineLicensesStatusTypeFilter: React.FC<MachineLicensesFilterProps> = ({
    value,
    onChange,
}) => {
    const { t } = useTranslation();

    // Convert enum to array of { value, label }
    const statusOptions = Object.entries(LicenseStatus)
        // filter out reverse-mapped numeric keys (TypeScript enum behavior)
        .filter(([key, val]) => isNaN(Number(key)))
        .map(([key, val]) => {
            // console.log("key ", key, "    val   ", val)
            return ({

                value: val.toString(), // The numeric enum value as string
                // cast to string so TypeScript accepts dynamic key
                label: t(`machinelicenses.licenseStatus.${val}` as unknown as any),// Localized label
            })
        });

    return (
        <SelectBoxWrapper>
            <Select
                mode="multiple"
                allowClear
                placeholder={t("machinelicenses.list.columns.status")}
                style={{ width: "100%" }}
                maxTagCount={1}
                options={statusOptions}
                onChange={onChange}
                value={value}
            />
        </SelectBoxWrapper>
    );
};